// extracted by mini-css-extract-plugin
export var container = "layout-module--container--7fcf9";
export var content = "layout-module--content--98b71";
export var main = "layout-module--main--f99ca";